import { ComponentPropsWithRef } from "react";

export const YouTubeIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 2.57143C0 1.88944 0.270918 1.23539 0.753154 0.753154C1.23539 0.270918 1.88944 0 2.57143 0L21.4286 0C22.1106 0 22.7646 0.270918 23.2468 0.753154C23.7291 1.23539 24 1.88944 24 2.57143V21.4286C24 22.1106 23.7291 22.7646 23.2468 23.2468C22.7646 23.7291 22.1106 24 21.4286 24H2.57143C1.88944 24 1.23539 23.7291 0.753154 23.2468C0.270918 22.7646 0 22.1106 0 21.4286L0 2.57143ZM8.49257 7.96457V16.2754C8.49343 16.4144 8.53103 16.5508 8.60155 16.6706C8.67207 16.7904 8.77302 16.8894 8.89415 16.9576C9.01528 17.0259 9.15229 17.0609 9.29131 17.0591C9.43032 17.0573 9.56638 17.0188 9.68571 16.9474L16.8 12.7937C16.92 12.7245 17.0196 12.625 17.0889 12.505C17.1582 12.3851 17.1947 12.2491 17.1947 12.1106C17.1947 11.9721 17.1582 11.836 17.0889 11.7161C17.0196 11.5962 16.92 11.4966 16.8 11.4274L9.68571 7.29257C9.56638 7.22124 9.43032 7.18273 9.29131 7.18094C9.15229 7.17914 9.01528 7.21413 8.89415 7.28235C8.77302 7.35058 8.67207 7.44961 8.60155 7.56942C8.53103 7.68923 8.49343 7.82555 8.49257 7.96457Z"
      fill="currentColor"
    />
  </svg>
);
